<template>
<v-container v-if="tournament">
  <div class="resumen_tournament">
    <v-row>
      <v-col>
    <div class="pt-3"> {{tournament.title}} </div>
      </v-col>
    </v-row>
    <v-row>
    <v-col v-if="tournament.club">
      <div>Club: {{tournament.club.name}}</div>
    </v-col>
      <v-col v-if="is_authenticated">
      <div><v-btn type="button" color="primary" @click="downloadFile" class="mr-4">Descargar listado inscritos</v-btn></div>
    </v-col>
  </v-row>
  </div>
<div>

<br>
  <v-table density="compact">
    <thead>
      <tr>
        <th class="text-center">
          Nombre
        </th>
        <th class="text-center">
          ID
        </th>
        <th class="text-center">
          ELO FIDE
        </th>
        <th v-if="is_authenticated" class="text-center">
          Rut
        </th>
        <th v-if="is_authenticated" class="text-center">
          Email
        </th>
        <th class="text-center">
          Estado
        </th>
        <th v-if="is_authenticated" class="text-center">
          Editar
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="item in tournament.inscriptions"
        :key="item.id"
        :class="{ 'green-background': item.person.canon == 1 && is_authenticated }"
      >
        <td class="text-left"><a :href="'/player/'+item.person.id" style="color:blue">{{ item.person.full_name }}</a></td>
        <td class="text-center">{{ item.person.federation_id }}</td>
        <td class="text-center">{{ item.person.elo_inter }}</td>
        <td v-if="is_authenticated" class="text-center">{{ item.person.identificator_format }}</td>
        <td v-if="is_authenticated" class="text-center">{{ item.person.email }}</td>
        <td class="text-center">{{ item.status_map }}</td>
        <td v-if="is_authenticated">
          <v-select
          :items="[{value:'P',title:'Pendiente'},{value:'A',title:'Confirmada'},{value:'R',title:'Elimiminada'},{value:'C',title:'Cancelada'}]"
          v-model="item.status"
          @update:modelValue="handleStatusChange(item)"
        >
             </v-select>
        </td>
      </tr>
    </tbody>
  </v-table>
  </div>
</v-container>

</template>
<script>

import {mapState} from "vuex";
import gql from "graphql-tag";
import axios from "axios";
export default {
  apollo: {
    tournament: {query: gql` query($id:String!){
       tournament(id:$id){
        title
        type
        address
        club {
          name
        }
        inscriptions:inscriptionsReal{
          id
          status_map:statusMap
          status
          person{
            identificator_format:identificatorFormat
            email
            id
            full_name:fullName
            federation_id:federationId
            elo_inter:eloInter
            canon
          }
        }
      }
    }`,
      variables() {return {"id" :this.id}}
    },
  },
  props:['id'],
    name:"SeeNewsChess",
  data() {

    return {
      a:'',
      tournament: null,
      download: false,
    }
  },
  computed: {
    ...mapState(['is_authenticated']),
  },
  methods: {
    downloadFile() {
      // Supongamos que la URL del archivo que deseas descargar es esta.
        if(this.download){
          return true
        }
      const fileUrl = '/export_tournament_csv/'+this.id;
      this.download = true;
      // Creas un elemento 'a', asignas la URL al atributo 'href' y disparas un click.
      const link = document.createElement('a');
      link.href = fileUrl;
      link.target = '_blank';
      link.download = 'miarchivo.csv'; // El nombre con el que se guardará el archivo.
      link.click();
    },
    onChange() {
      console.log("this.content",this.content)
    },
    uploadCallback(url) {
      console.log('uploaded url', url)
    },
    handleStatusChange(item) {
      const url = '/update_model_inscription/';
      // Aquí puedes manejar el cambio de estado, por ejemplo, hacer una llamada API para actualizar el estado en tu servidor.
      console.log('Status changed for inscription', item.status);
      axios.post(url, item).then(() => {
        alert("cambio aplicado con exito")
      })
      .catch(error => {
        alert("datos ingresados no validos")
        console.log(error)
      })
    },
  },
  watch:{
    '$apollo.loading'(val){
      if(!val && this.id){
        this.tournament = JSON.parse(JSON.stringify(this.tournament))
      }
    },
  }
}
</script>
<style>
.resumen_tournament{
  font-family: Montserrat;
font-size: 30px;
font-weight: 600;
line-height: 37px;
letter-spacing: 0em;
text-align: left;
color: #F4F4F4;
  background-color:#2A4558;
  text-align: center;

}
@media (max-width: 600px) {
  .resumen_tournament{
    font-size: 24px;
  }
}
.green-background {
  background-color: #99D49E;
}
</style>
